<!-- AlertDialog.vue -->
<template>
	<div v-if="show" class="search-dialog">
    <div v-if="isShowBack" class="back" @click="close">
      <img src="../assets/image/red/back.png"/>
    </div>
		<transition name="fade">
			<div class="search-dialog-content" v-show="fade">
				<div class="title">可视化财报<p style="margin-top: -20px; font-size: 22px;">Visual Financial Report</p></div>
				<div class="content">
					<div class="input">
            <input class="name" placeholder="请输入证券代码或简称" v-model="keyword" :style="{ outline: 'none', boxShadow: 'none', borderColor: '#ccc', border: 'none'}"/>
						<div class="line"></div>
						<el-select class="select" style="width: 100px" v-model="year" placeholder="年份">
							<el-option value="">全部</el-option>
							<el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
						<div class="line"></div>
						<el-select class="select" style="width: 137px" v-model="cycle" placeholder="报告周期">
							<el-option value="">全部</el-option>
							<el-option v-for="item in cycleList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
						</el-select>
						<div class="line"></div>
						<el-cascader
							class="select"
							placeholder="行业"
							style="width: 194px"
							v-model="industry"
							:options="industryList"
							:props="{ expandTrigger: 'hover', value: 'id', label: 'text', multiple: true }"
							:show-all-levels="false"
						></el-cascader>
					</div>

          <el-dropdown trigger="click" ref="messageDrop" v-show="searchReportData">
            <el-dropdown-menu class="custom-dropdown-menu">
              <el-dropdown-item v-for="(item, index) in reportList" :key="index" @click.native="handleCutIframeUrl(item)">
                {{ item.name }}    <span class="el-tag">{{item.xfhyCode2}}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
					<div class="search" @click="searchReport">
						<img src="../assets/image/red/search1.png" />
					</div>
				</div>
			</div>
		</transition>
		<div class="logo">
			<img src="../assets/image/red/logo.png" />
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import {mapState} from "vuex";
import jsonp from 'jsonp';
export default {
	name: 'SearchDialog',
	props: {
		show: {
			type: Boolean,
			default: false,
		},

	},
	data() {
		return {
			fade: false,
      searchReportData: false,
			selectedOption: '',
			keywordList: [],
      reportList:[],
			yearList: [],
			// period（枚举值是year Q3 half Q1） 年度、前三季度、半年度、一季度
			cycleList: [
				{ value: 'year', label: '年度' },
				{ value: 'half', label: '半年度' },
				{ value: 'Q3', label: '前三季度' },
				{ value: 'Q1', label: '一季度' },
			],
			keyword: '',
			year: '',
			cycle: '',
			industry: '',
			resultList: [],
			loading: false,
			industryList: [],
      isShowBack: window.location.href.indexOf('?') === -1 ? false : true,
		}
	},
	mounted() {
		this.fade = true
		this.getIndustryData()
    document.title = "聚合搜索";
		for (let i = new Date().getFullYear(); i >= 2022; i--) {
      this.yearList.push({ value: i, label: i + '年' })
    }
  },
  computed: {
    ...mapState(['envConfig'])
  },
	methods: {
		getIndustryData() {
      axios.get('industry.json').then(res => {
				this.industryList = res.data;
        this.industryList.forEach(item => {
          item.text = item.id + ' ' + item.text;
          item.children.forEach(child => {
            child.text = child.id + ' ' + child.text;
          });
        });
			})
		},
		close() {
			this.$emit('update:show', false) // 通知父组件关闭弹窗
		},
    searchReport() {
      const url = `${this.envConfig.serverUrl}/open/api/reportData`;
      const params = {
        rec: 1,
        pageSize: '20',
        year: this.year,
        period: this.cycle,
        companyCode: this.keyword,
        xfhyCode2: this.industry ? this.industry.map(item => item[1]).toString() : ''
      };
      const queryString = new URLSearchParams(params).toString();
      const jsonpUrl = `${url}?${queryString}`;

      jsonp(jsonpUrl, null, (err, data) => {
        if (err) {
          console.error('请求失败', err);
          return;
        }
        console.log(data);
        if (data.length > 0) {
          this.reportList = data;
          this.searchReportData = true;
          this.$refs.messageDrop.show();
        } else if (this.keyword !== '') {
          this.$alert('当前无该公司可视化财报。', '', {
            confirmButtonText: '确认'
          });
        } else {
          this.$alert('未查询到可视化财报。', '', {
            confirmButtonText: '确认'
          });
        }
      });
      // let url = this.envConfig.serverUrl + '/open/api/reportData';
      // axios.post(url, {}, {
      //       params: {
      //         rec: 1,
      //         pageSize: '20',
      //         year: this.year,
      //         period: this.cycle,
      //         companyCode: this.keyword,
      //         xfhyCode2: this.industry ? this.industry.map(item => item[1]).toString() : ''
      //       }
      //     }
      // ).then(res => {
      //   if (res.data.code === 200 && res.data.data.length > 0) {
      //     this.reportList = res.data.data
      //     this.searchReportData = true
      //     this.$refs.messageDrop.show()
      //     return
      //   }
      //   this.$alert('未查询到相关财报数据！', '', {
      //     confirmButtonText: '确认'
      //   });
      // })
    },
    handleCutIframeUrl(item) {
      if (item.version === '3.0' || item.version === '4.0') {
        if (location.href === item.pcUrl) {
          location.reload();
          return;
        }
        location.href = item.pcUrl;
      } else {
        // 尝试从父窗口打开
        // 当页面https且链接以http开头时，替换为https
        if (window.location.protocol === 'https:' && item.pcUrl.startsWith('http://')) {
          item.pcUrl = item.pcUrl.replace('http://', 'https://');
        }
        if (window.top !== window.self) { // 如果在父窗口中，则尝试从父窗口中打开新窗口
          window.top.open(item.pcUrl, '_blank');
        } else {
          // 如果无法从父窗口打开，则直接在当前窗口打开
          window.open(item.pcUrl, '_blank');
        }
      }
    }
	},
}
</script>

<style scoped>
.search-dialog {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1000;
	width: 100%;
	height: 100%;
	background-image: url(../assets/image/red/search_bg.jpg);
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.title {
	margin-top: 170px;
	width: 100%;
	height: 100px;
	font-weight: bold;
	font-size: 48px;
	color: #ffffff;
	line-height: 72px;
	text-align: center;
	font-style: normal;
}
.content {
	margin-top: 42px;
	display: flex;
	justify-content: center;
}
.input {
	width: 733px;
	height: 60px;
	background: #ffffff;
	border-radius: 8px 0px 0px 8px;
	display: flex;
	align-items: center;
}
.search {
	width: 72px;
	height: 60px;
	background: #2B60DB;
	border-radius: 0px 8px 8px 0px;
	display: flex;
	justify-content: center;
	align-items: center;
  cursor: pointer;
}

.search img {
	width: 45px;
	height: 45px;
}

.name {
	width: 299px;
	margin-left: 18px;
}

/deep/.el-input__inner {
	border: none !important;
	padding-left: 0;
	font-size: 18px;
}
/deep/.el-input__inner::-webkit-input-placeholder {
	/* Chrome/Opera/Safari */
	font-weight: 400;
	font-size: 18px;
	color: #999999;
	line-height: 25px;
}
/deep/.el-input__inner::-moz-placeholder {
	/* Firefox 19+ */
	font-weight: 400;
	font-size: 18px;
	color: #999999;
	line-height: 25px;
}
/deep/.el-input__inner:-ms-input-placeholder {
	/* IE 10+ */
	font-weight: 400;
	font-size: 18px;
	color: #999999;
	line-height: 25px;
}
.select /deep/.el-input__inner::-webkit-input-placeholder {
	/* Chrome/Opera/Safari */
	font-weight: 400;
	font-size: 18px;
	color: #343434;
}
.select /deep/.el-input__inner::-moz-placeholder {
	/* Firefox 19+ */
	font-weight: 400;
	font-size: 18px;
	color: #343434;
}
.select /deep/.el-input__inner:-ms-input-placeholder {
	/* IE 10+ */
	font-weight: 400;
	font-size: 18px;
	color: #343434;
}
.line {
	width: 1px;
	height: 37px;
	background-color: #f0f0f0;
}
.select {
	margin-left: 7px;
}
.select /deep/ .el-input__suffix .el-select__caret {
	color: #343434;
	font-size: 16px;
}
.select /deep/ .el-input__suffix {
	color: #343434;
}
.select /deep/ .el-icon-arrow-down {
	font-size: 16px;
}

.back {
	position: absolute;
	top: 40px;
	left: 45px;
	cursor: pointer; /* 设置光标形状为手型 */
}
.back img {
	width: 28px;
	height: 34px;
}

.logo {
	position: absolute;
	width: 100%;
	text-align: center;
	bottom: 64px;
}
.logo img {
	width: 112px;
	height: 35px;
}
.el-tag {
  background-color: #fff;
  display: inline-block;
  height: 28px;
  line-height: 26px;
  width: 50px;
  padding: 0 10px;
  font-size: 12px;
  color: #409eff;
  border: 1px solid #a0cfff;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
  float: right;
  margin-top: 5px;
  margin-left: -80px;
  margin-right: 80px;
}
.custom-dropdown-menu {
  width: 730px;
  margin-right: 15px;
  text-align: center;
  border-radius: 5px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
